import React from "react";

const Badge = ({ text }) => (
  <span className="inline-block bg-green-100 text-green-800 text-xs font-semibold px-2 py-1 rounded-full ml-2">
    {text}
  </span>
);

const WhyVerifyPage = () => {
  const sections = [
    {
      title: "Protecting Buyers",
      icon: "🛡️",
      content: (
        <>
          When you purchase a client or service through our platform, you want confidence that you’re dealing with a genuine business. ClientExchange uses verification measures, including ABN checks and third-party identity verification, to help reduce the risk of scams or fake listings.
        </>
      ),
    },
    {
      title: "Protecting Sellers",
      icon: "🔒",
      content: (
        <>
          Sellers also benefit from verification. Users who complete verification may receive a <Badge text="Verified Business" /> badge, helping attract serious buyers. Your real identity and company information are not displayed publicly.
        </>
      ),
    },
    {
      title: "Keeping the Platform Professional",
      icon: "🏆",
      content: (
        <>
          ClientExchange is designed for professional businesses, not casual operators. Requiring ABN and third-party identity verification helps keep the platform high-quality and credible.
        </>
      ),
    },
    {
      title: "Privacy Comes First",
      icon: "🕵️‍♂️",
      content: (
        <>
          ClientExchange uses a third-party identity verification provider, Stripe Identity, to assist in confirming user identity. Sensitive identity documents are processed securely by the provider and are not stored directly by ClientExchange. Public listings show only a display name and <Badge text="Verified Business" /> badge.
        </>
      ),
    },
    {
      title: "Building Trust",
      icon: "🤝",
      content: (
        <>
          Verification helps build trust between users. Buyers can see when they are dealing with a <Badge text="Verified Business" />, and sellers know the platform is designed for genuine business users.
        </>
      ),
    },
  ];

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", padding: "40px 16px" }}>
  <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
      <h1 className="text-4xl font-bold text-center text-gray-900">
        Why We Verify Businesses
      </h1>

      <p className="text-lg text-center text-gray-700">
        At <strong>ClientExchange</strong>, our mission is to connect genuine,
        professional businesses with buyers and other businesses looking to buy,
        sell, or swap clients. Verification helps improve trust and reduce risk
        across the platform.
      </p>

      <div className="grid gap-6 md:grid-cols-2">
        {sections.map((section, idx) => (
          <div
            key={idx}
            className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300"
          >
            <div className="flex items-center mb-4">
              <span className="text-3xl mr-3">{section.icon}</span>
              <h2 className="text-2xl font-semibold text-gray-800">
                {section.title}
              </h2>
            </div>
            <p className="text-gray-700">{section.content}</p>
          </div>
        ))}
      </div>

      <p className="text-center text-gray-600 text-sm">
        Verification helps improve trust on the platform but does not guarantee
        the identity, legitimacy, conduct, or performance of any user.
      </p>

      <p className="text-center text-gray-800 font-semibold text-lg">
        Thank you for helping us keep ClientExchange a trusted place for all
        businesses.
      </p>
              </div>
      </div>
  );
};

export default WhyVerifyPage;